"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dateFormatter = /** @class */ (function () {
    function dateFormatter() {
    }
    dateFormatter.prototype.setDateinFormat = function (year, month, date, hours, minutes, seconds, milliseconds, timezone) {
        var diff = timezone >= 0 ? '+' : '-';
        var pad = function (n) { return ("" + Math.floor(Math.abs(n))).padStart(2, '0'); };
        return year + '-' + pad(month + 1) + '-' + pad(date) + 'T' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds) + '.' + pad((milliseconds / 10) | 0) + diff + pad(timezone / 60) + ':' + pad(timezone % 60);
    };
    dateFormatter.prototype.getDateWithTimeZone = function (inputDate) {
        if (Date.parse(inputDate)) {
            var date = new Date(inputDate);
            return this.setDateinFormat(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds(), -date.getTimezoneOffset());
        }
        else {
            return 'date is invalid';
        }
    };
    return dateFormatter;
}());
exports.dateFormatter = dateFormatter;
//# sourceMappingURL=date.formatter.js.map